import { editorPagesAtom } from '@/atoms/_editorAtoms'
import { useRecoilState } from 'recoil'
import { updateThemeOverride } from 'utils'

export const useApplyThemeOverrideToPages = () => {
  const [editorPages, setEditorPages] = useRecoilState(editorPagesAtom)

  return (selectedPages, layoutUpdates) => {
    const updatedPages = editorPages.map((originalPage, i) => {
      // determine if the page is even or odd
      const currentPage = i + 1
      const pagePosition = currentPage % 2 === 0 ? 'even' : 'odd'

      // determine if the page will be affected by the changes or not
      const allPagesSelected = selectedPages === 'all'
      const isSelectedPage = allPagesSelected || selectedPages === pagePosition

      // only apply changes to selected pages
      if (isSelectedPage) {
        const updatedPage = updateThemeOverride({
          originalPage,
          layoutUpdates,
        })

        return updatedPage
      } else {
        // return the original page
        return originalPage
      }
    })

    // update the pages atom
    setEditorPages(updatedPages)
  }
}

export default useApplyThemeOverrideToPages
